import React from "react";
import { STATS } from "@/data/mock";
import AnimatedCounter from "@/components/shared/AnimatedCounter";
import { FadeUp } from "@/components/shared/RevealText";

export default function Statistics() {
    return (
        <section className="relative bg-ink text-white py-24 md:py-32" data-testid="statistics-section">
            <div className="container-x">
                <div className="mb-16 grid grid-cols-1 items-end gap-8 md:grid-cols-12">
                    <FadeUp className="md:col-span-7">
                        <div className="eyebrow mb-4 !text-pink">Ch. 03 · By the numbers</div>
                        <h2 className="h-display font-display text-[40px] font-black leading-[0.95] text-white md:text-[64px]">
                            Signals from
                            <br />
                            the <span className="serif-italic text-pink">field</span>.
                        </h2>
                    </FadeUp>
                    <FadeUp delay={0.1} className="md:col-span-5">
                        <p className="max-w-md text-[15px] leading-relaxed text-white/70 md:text-[16px]">
                            Illustrative statistics for the concept. Every metric visible here would be tied to a real,
                            auditable citizen action in production.
                        </p>
                    </FadeUp>
                </div>

                <div className="grid grid-cols-2 gap-8 border-y border-white/10 py-14 md:grid-cols-4">
                    {STATS.map((s, i) => (
                        <FadeUp key={s.label} delay={i * 0.08}>
                            <div className="flex flex-col gap-3">
                                <div className="text-[11px] font-semibold uppercase tracking-[0.28em] text-white/50">
                                    0{i + 1}
                                </div>
                                <div className="font-display text-[46px] font-black leading-none tracking-tighter text-white md:text-[68px]">
                                    <AnimatedCounter value={s.value} testId={`stat-${i}`} />
                                    {s.suffix}
                                </div>
                                <div className="text-[13px] font-medium text-white/70">{s.label}</div>
                            </div>
                        </FadeUp>
                    ))}
                </div>

                <div className="mt-8 flex items-center justify-between text-[11px] uppercase tracking-[0.28em] text-white/50">
                    <span>Updated live · illustrative</span>
                    <span className="hidden md:inline">Source · Platform activity</span>
                </div>
            </div>
        </section>
    );
}
